import React, { useState } from 'react';
import { X, Camera } from 'lucide-react';

const CompanionPairingModal = ({ onClose, userId }) => {
    const [mode, setMode] = useState('generate'); // 'generate' or 'scan'
    const qrData = `cricmaster://pair/${userId}`;

    return (
        <div className="fixed inset-0 bg-black/90 z-50 flex flex-col">
            {/* Header */}
            <div className="p-4 bg-gray-800 flex items-center justify-between border-b border-gray-700">
                <h2 className="text-white font-bold">Link Non-Striker</h2>
                <button onClick={onClose} className="text-gray-400 hover:text-white">
                    <X size={20} />
                </button>
            </div>

            {/* Mode Toggle */}
            <div className="p-4 flex gap-2">
                <button
                    onClick={() => setMode('generate')}
                    className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${mode === 'generate' ? 'bg-neon-cyan text-black' : 'bg-gray-700 text-gray-400'}`}
                >
                    Show My Code
                </button>
                <button
                    onClick={() => setMode('scan')}
                    className={`flex-1 py-2 rounded-lg text-sm font-bold transition ${mode === 'scan' ? 'bg-neon-cyan text-black' : 'bg-gray-700 text-gray-400'}`}
                >
                    Scan Partner's
                </button>
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col items-center justify-center p-8">
                {mode === 'generate' ? (
                    <>
                        {/* QR Code Placeholder (In production, use a QR library like qrcode.react) */}
                        <div className="w-48 h-48 bg-white rounded-2xl flex items-center justify-center p-4 shadow-2xl">
                            <div className="w-full h-full bg-gray-200 rounded-lg flex items-center justify-center">
                                <span className="text-gray-500 text-xs text-center font-mono break-all">{qrData}</span>
                            </div>
                        </div>
                        <p className="text-gray-400 text-sm mt-6 text-center">
                            Have your partner scan this code to form a <span className="text-neon-cyan font-bold">Non-Striker Bond</span>
                        </p>
                        <p className="text-gray-600 text-xs mt-2">They'll be able to view your training plan</p>
                    </>
                ) : (
                    <>
                        {/* Scan UI Placeholder */}
                        <div className="w-64 h-64 border-4 border-dashed border-neon-cyan/50 rounded-2xl flex items-center justify-center relative overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-b from-neon-cyan/10 to-transparent animate-pulse"></div>
                            <Camera size={48} className="text-gray-600" />
                        </div>
                        <p className="text-gray-400 text-sm mt-6 text-center">
                            Point camera at partner's QR code
                        </p>
                    </>
                )}
            </div>

            {/* "Bat Tap" Haptic Hint */}
            <div className="p-4 bg-gray-800 border-t border-gray-700 text-center">
                <p className="text-gray-500 text-xs">
                    🏏 When connected, both phones will vibrate with a "Bat Tap"
                </p>
            </div>
        </div>
    );
};

export default CompanionPairingModal;
